/**
 * package: com.inq.ui
 * class: Keyboard
 * root Object
 * @constructor
 */
com.inq.ui.Keyboard = function() {
};
$hxClasses.registerClass(com.inq.ui.Keyboard, "com.inq.ui.Keyboard");
/** @type {boolean} */
com.inq.ui.Keyboard.capsLock = null;

/**
 * isAccessible
 *
 * $type TFun([],TEnum(Bool,[]))
 * @private
 * @static
 * @return {boolean}
 */
com.inq.ui.Keyboard.isAccessible = function() {
	return true;
};

/** @private @type {boolean} */
com.inq.ui.Keyboard.numLock = null;
/** @type {com.inq.ui.Keyboard} */
com.inq.ui.Keyboard.prototype.__class__ = com.inq.ui.Keyboard;
/** @type {number} */
com.inq.ui.Keyboard.BACKSPACE = 8;

/** @type {number} */
com.inq.ui.Keyboard.CAPS_LOCK = 20;

/** @type {number} */
com.inq.ui.Keyboard.CONTROL = 17;

/** @type {number} */
com.inq.ui.Keyboard.DELETE = 46;

/** @type {number} */
com.inq.ui.Keyboard.DOWN = 40;

/** @type {number} */
com.inq.ui.Keyboard.END = 35;

/** @type {number} */
com.inq.ui.Keyboard.ENTER = 13;

/** @type {number} */
com.inq.ui.Keyboard.ESCAPE = 27;

/** @type {number} */
com.inq.ui.Keyboard.F1 = 112;

/** @type {number} */
com.inq.ui.Keyboard.F2 = 113;

/** @type {number} */
com.inq.ui.Keyboard.F3 = 114;

/** @type {number} */
com.inq.ui.Keyboard.F4 = 115;

/** @type {number} */
com.inq.ui.Keyboard.F5 = 116;

/** @type {number} */
com.inq.ui.Keyboard.F6 = 117;

/** @type {number} */
com.inq.ui.Keyboard.F7 = 118;

/** @type {number} */
com.inq.ui.Keyboard.F8 = 119;

/** @type {number} */
com.inq.ui.Keyboard.F9 = 120;

/** @type {number} */
com.inq.ui.Keyboard.F10 = 121;

/** @type {number} */
com.inq.ui.Keyboard.F11 = 122;

/** @type {number} */
com.inq.ui.Keyboard.F12 = 123;

/** @type {number} */
com.inq.ui.Keyboard.F13 = 124;

/** @type {number} */
com.inq.ui.Keyboard.F14 = 125;

/** @type {number} */
com.inq.ui.Keyboard.F15 = 126;

/** @type {number} */
com.inq.ui.Keyboard.HOME = 36;

/** @type {number} */
com.inq.ui.Keyboard.PAUSE = 19;

/** @type {number} */
com.inq.ui.Keyboard.INSERT = 45;

/** @type {number} */
com.inq.ui.Keyboard.LEFT = 37;

/** @type {number} */
com.inq.ui.Keyboard.NUMPAD_0 = 96;

/** @type {number} */
com.inq.ui.Keyboard.NUMPAD_1 = 97;

/** @type {number} */
com.inq.ui.Keyboard.NUMPAD_2 = 98;

/** @type {number} */
com.inq.ui.Keyboard.NUMPAD_3 = 99;

/** @type {number} */
com.inq.ui.Keyboard.NUMPAD_4 = 100;

/** @type {number} */
com.inq.ui.Keyboard.NUMPAD_5 = 101;

/** @type {number} */
com.inq.ui.Keyboard.NUMPAD_6 = 102;

/** @type {number} */
com.inq.ui.Keyboard.NUMPAD_7 = 103;

/** @type {number} */
com.inq.ui.Keyboard.NUMPAD_8 = 104;

/** @type {number} */
com.inq.ui.Keyboard.NUMPAD_9 = 105;

/** @type {number} */
com.inq.ui.Keyboard.NUMPAD_ADD = 107;

/** @type {number} */
com.inq.ui.Keyboard.NUMPAD_DECIMAL = 110;

/** @type {number} */
com.inq.ui.Keyboard.NUMPAD_DIVIDE = 111;

/** @type {number} */
com.inq.ui.Keyboard.NUMPAD_ENTER = 108;

/** @type {number} */
com.inq.ui.Keyboard.NUMPAD_MULTIPLY = 106;

/** @type {number} */
com.inq.ui.Keyboard.NUMPAD_SUBTRACT = 109;

/** @type {number} */
com.inq.ui.Keyboard.PAGE_DOWN = 34;

/** @type {number} */
com.inq.ui.Keyboard.PAGE_UP = 33;

/** @type {number} */
com.inq.ui.Keyboard.RIGHT = 39;

/** @type {number} */
com.inq.ui.Keyboard.SHIFT = 16;

/** @type {number} */
com.inq.ui.Keyboard.SPACE = 32;

/** @type {number} */
com.inq.ui.Keyboard.TAB = 9;

/** @type {number} */
com.inq.ui.Keyboard.UP = 38;

